import config from "../config.js";

export const dateToString = date => {
  return date
    ? date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    : "";
};

/**
 * join css classes together
 * @param classes , the css classes to join
 */
export const joinCss = (...classes) => {
  if (classes == null || classes.length == 0) return "";
  return classes.join(" ");
};

export const getFileLink = (id, pdfName) => {
  return (
    config.proxy +
    config.assetsPath +
    encodeURIComponent(id + "-" + pdfName) +
    ".pdf"
  );
};

export const getFileLinkWithPage = (id, pdfName, page) => {
  const link = getFileLink(id, pdfName) + "#page=" + page;
  return link;
};

export const getZipFileLink = name => {
  return config.proxy + "/zip/" + name;
};

export const isNullOrEmpty = str => {
  return str == null || str.length === 0 || str.trim().length === 0;
};

const isRegularEmailChar = c => {
  return (c >= "a" && c <= "z") || (c >= "0" && c <= "9");
};

const rex = /[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\\.[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*/;

export const StrIsEmailValidation = emailStr => {
  if (isNullOrEmpty(emailStr)) return false;

  const email = String(emailStr)
    .toLowerCase()
    .trim();
  const rxRes = rex.test(email);

  if (rxRes) {
    const counter = {};
    counter["@"] = 0;
    counter["."] = 0;
    counter[":"] = 0;
    counter["/"] = 0;
    counter[" "] = 0;
    counter[","] = 0;

    for (var i = 0; i < email.length; i++) {
      switch (email[i]) {
        case "@":
          counter["@"]++;
          break;
        case ".":
          counter["."]++;
          break;
        case ":":
          counter[":"]++;
          break;
        case "/":
          counter["/"]++;
          break;
        case " ":
          counter[" "]++;
          break;
        case ",":
          counter[","]++;
          break;
      }
    }
    if (counter["@"] == 1 && counter["."] > 0) {
      if (
        counter[":"] == 0 &&
        counter["/"] == 0 &&
        counter[" "] == 0 &&
        counter[","] == 0
      ) {
        var arr = email.split("@");
        var arr2 = arr[arr.length - 1].split(".");

        var local = arr[0];
        var ext = arr2[arr2.length - 1];
        var domain = arr[arr.length - 1];
        domain = domain.substr(0, domain.length - 1 - ext.length);

        if (
          !isNullOrEmpty(local) &&
          !isNullOrEmpty(domain) &&
          !isNullOrEmpty(ext)
        ) {
          if (
            domain.length < 255 &&
            domain.charAt(0) !== "-" &&
            domain.charAt(domain.length - 1) !== "-"
          )
            if (
              Array.from(domain).every(
                c => isRegularEmailChar(c) || (c === "." || c === "-")
              )
            ) {
              if (
                email.indexOf("..") == -1 &&
                Array.from(ext).every(c2 => isRegularEmailChar(c2))
              ) {
                //success , string is email
                return true;
              }
            }
        }
      }
    }
  }
  return false;
};
